if (!customElements.get('lighting-specifications')) {
  customElements.define('lighting-specifications', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const initialise = () => {
        if (!this.isConnected) return;
        this.variants = JSON.parse(this.querySelector('[data-lighting-variants]').textContent);
        this.source = this.querySelector('[data-lighting-source]');
        this.output = this.querySelector('[data-lighting-content]');
        this.labels = this.dataset.labels.split('|');
        this.tags = JSON.parse(this.dataset.tags);
        this.selector = this.closest('.product--outer')?.querySelector('variant-selection');
        this.update();
        if (this.selector) {
          this.observer = new MutationObserver(() => this.update());
          this.observer.observe(this.selector, { attributes: true, attributeFilter: ['variant'] });
        }
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
      else initialise();
    }
    disconnectedCallback() { this.observer?.disconnect(); this.ready = false; }
    update() {
      const id = this.selector?.getAttribute('variant') || this.dataset.initialVariant;
      const variant = this.variants.find(item => String(item.id) === id);
      this.output.replaceChildren();
      if (!variant) { this.output.textContent = this.dataset.choose; return; }
      const title = document.createElement('p');
      const strong = document.createElement('strong');
      strong.textContent = variant.title;
      title.append(strong);
      this.output.append(title);
      const fragment = this.source.content.cloneNode(true);
      const headings = Array.from(fragment.querySelectorAll('h3'));
      const details = document.createElement('div');
      if (headings.length) {
        const heading = headings.find(item => item.textContent.trim() === variant.title.trim());
        let next = heading?.nextSibling;
        while (next && !(next.nodeType === 1 && next.tagName === 'H3')) {
          const following = next.nextSibling;
          details.append(next);
          next = following;
        }
      } else details.append(fragment);
      const text = details.textContent.replace(/\s+/g, ' ');
      const led = text.match(/No of LEDS:\s*(\d+)/i) || variant.title.match(/(\d+)\s*(?:LED|Bulb)/i) || (!headings.length && this.dataset.productTitle.match(/(\d+)\s*LED/i));
      const duration = text.match(/\d+\s*(?:hours?|hrs?)\s*on\s*[,/]\s*\d+\s*(?:hours?|hrs?)\s*off/i);
      const cable = text.match(/\d+(?:\.\d+)?m\s+cable\s+(?:from|between)\s+transformer\s+(?:to|and)\s+first\s+bulb/i) || text.match(/Battery box to first bulb:\s*\d+(?:\.\d+)?m/i) || text.match(/Cable length to first light\s*\d+(?:\.\d+)?m/i);
      const power = this.tags.filter(t => t.startsWith('Power: ')).map(t => t.slice(7)).join(' / ');
      const use = this.tags.filter(t => t.startsWith('Use: ')).map(t => t.slice(5)).join(' / ');
      const timer = duration ? duration[0] : (/timer/i.test(text + ' ' + this.dataset.productTitle) ? this.dataset.timer : '');
      const values = [power, use, led ? led[1] : '', cable ? cable[0] : '', timer];
      const table = document.createElement('table');
      const tbody = document.createElement('tbody');
      values.forEach((value, index) => {
        const row = document.createElement('tr');
        const key = document.createElement('th');
        key.scope = 'row'; key.textContent = this.labels[index];
        const cell = document.createElement('td'); cell.textContent = value || this.dataset.missing;
        row.append(key, cell); tbody.append(row);
      });
      table.append(tbody);
      this.output.append(table, details);
    }
  });
}
